<template>
  <div>
    <!-- NAVIGATION DRAWERX -->
    <v-navigation-drawer
      width="250"
      app
      absolute
      clipped
      v-model="drawer"
      :mini-variant="mini"
    >
      <v-flex>
        <v-toolbar-side-icon
          class="center"
          v-if="mini"
          style="color: #fff"
          @click.stop="
            mini = !mini;
            setTitleMargin();
          "
        ></v-toolbar-side-icon>
        <div
          class="close-menu text-xs-right"
          @click.stop="
            mini = !mini;
            setTitleMargin();
          "
          v-if="!mini"
          title="Collapse Menu"
        >
          <v-icon color="#fff">mdi-chevron-left-circle</v-icon>
        </div>
      </v-flex>
      <!-- <div class="logo">
        <a
          href="https://www.giveovation.com/"
          target="_blank"
          title="www.giveovation.com"
          v-if="mini"
        >
          <v-img
            height="50px"
            v-if="mini"
            :src="require('@/assets/img/mini-logo-Ovation.png')"
            contain
          ></v-img>
        </a>
        <a
          href="https://www.giveovation.com/"
          target="_blank"
          title="www.giveovation.com"
          v-if="!mini"
        >
          <v-img
            height="60px"
            v-if="!mini"
            :src="require('@/assets/img/logo-Ovation.v3.png')"
            contain
          ></v-img>
        </a>
      </div> -->
      <v-list dense>
        <!-- <v-divider></v-divider> -->
        <!-- Dashboard -->
        <v-list-tile title="Dashboard" to="/dashboard">
          <v-list-tile-action>
            <v-icon
              :style="
                'color:' + $store.state.colorScheme.navigation.font.normal
              "
              >mdi-view-dashboard-outline</v-icon
            >
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              <span
                class="font-weight-bold"
                :style="
                  'color:' + $store.state.colorScheme.navigation.font.normal
                "
                >Dashboard</span
              >
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <!-- Recent Dashboard -->
        <v-list-tile
          v-if="
            ($store.getters.isOrgAdmin ||
              $store.getters.isOrgOwner ||
              $store.getters.isSuperAdmin) &&
            !$store.getters.isCurrentOrgChild
          "
          title="Recent Dashboard"
          :to="
            '/recentdashboard/' +
            $store.getters.getOrgIdentifier +
            '?token=' +
            $store.getters.getOrgToken
          "
          target="_blank"
        >
          <v-list-tile-action>
            <v-icon
              :style="
                'color:' + $store.state.colorScheme.navigation.font.normal
              "
              >mdi-open-in-new</v-icon
            >
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              <span
                class="font-weight-bold"
                :style="
                  'color:' + $store.state.colorScheme.navigation.font.normal
                "
                >Recent Dashboard</span
              >
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <!-- Organization -->
        <v-list-tile
          v-if="
            $store.getters.isOrgAdmin ||
            $store.getters.isOrgOwner ||
            $store.getters.isHRManager ||
            $store.getters.isSuperAdmin
          "
          title="Manage Organizations"
          to="/organization"
        >
          <v-list-tile-action>
            <v-icon
              :style="
                'color:' + $store.state.colorScheme.navigation.font.normal
              "
              >mdi-office-building</v-icon
            >
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              <span
                class="font-weight-bold"
                :style="
                  'color:' + $store.state.colorScheme.navigation.font.normal
                "
                >Manage Orgs</span
              >
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <!-- Add Funds -->
        <!-- ** Only display if user has SuperAdmin Role ** -->
        <v-list-tile
          title="Manage Funds"
          to="/managefunds"
          v-if="
            $store.getters.isSuperAdmin && !$store.getters.isCurrentOrgChild
          "
        >
          <v-list-tile-action>
            <v-icon
              :style="
                'color:' + $store.state.colorScheme.navigation.font.normal
              "
              >mdi-coin</v-icon
            >
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              <span
                class="font-weight-bold"
                :style="
                  'color:' + $store.state.colorScheme.navigation.font.normal
                "
                >Manage Funds</span
              >
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <!-- Bounty Board -->
        <v-list-tile
          v-if="$store.getters.bountyBoardEnabled"
          title="Bounty Board"
          to="/bountyboard"
        >
          <v-list-tile-action>
            <v-icon
              :style="
                'color:' + $store.state.colorScheme.navigation.font.normal
              "
              >mdi-trophy-outline</v-icon
            >
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              <span
                :style="
                  'color:' + $store.state.colorScheme.navigation.font.normal
                "
                >Bounty Board</span
              >
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <!-- Learn & Earn -->
        <v-list-tile
          v-if="$store.getters.learnAndEarnEnabled"
          title="Learn & Earn"
          to="/learningboard"
        >
          <v-list-tile-action>
            <v-icon
              :style="
                'color:' + $store.state.colorScheme.navigation.font.normal
              "
              >mdi-school</v-icon
            >
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              <span
                :style="
                  'color:' + $store.state.colorScheme.navigation.font.normal
                "
                >Learn & Earn</span
              >
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <!-- Buy Ovations -->
        <v-list-tile
          v-if="
            ($store.getters.isOrgAdmin ||
              $store.getters.isOrgOwner ||
              $store.getters.isHRManager ||
              $store.getters.isSuperAdmin) &&
            !$store.getters.isCurrentOrgChild
          "
          title="Buy Ovations"
          to="/buyovations"
        >
          <v-list-tile-action>
            <v-icon
              :style="
                'color:' + $store.state.colorScheme.navigation.font.normal
              "
              >mdi-cart-outline</v-icon
            >
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              <span
                class="font-weight-bold"
                :style="
                  'color:' + $store.state.colorScheme.navigation.font.normal
                "
                >Buy Ovations</span
              >
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <!-- Distribute Ovations -->
        <!-- ** Only display if the user is the owner of the organization -->
        <v-list-tile
          title="Distribute Ovations"
          to="/assignovations"
          v-if="
            ($store.getters.isOrgOwner || $store.getters.isSuperAdmin) &&
            !$store.getters.isCurrentOrgChild
          "
        >
          <v-list-tile-action>
            <v-icon
              :style="
                'color:' + $store.state.colorScheme.navigation.font.normal
              "
              >mdi-plus-circle-multiple-outline</v-icon
            >
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              <span
                class="font-weight-bold"
                :style="
                  'color:' + $store.state.colorScheme.navigation.font.normal
                "
                >Distribute Ovations</span
              >
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <!-- Send Ovations -->
        <v-list-tile title="Send Ovations" to="/giveovations">
          <v-list-tile-action>
            <v-icon
              :style="
                'color:' + $store.state.colorScheme.navigation.font.normal
              "
              >mdi-coins</v-icon
            >
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              <span
                class="font-weight-bold"
                :style="
                  'color:' + $store.state.colorScheme.navigation.font.normal
                "
                >Send Ovations</span
              >
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <!-- Bounty -->
        <!-- <v-list-tile title="Bounty" to="/bounty">
          <v-list-tile-action>
            <v-icon :style="'color:'+$store.state.colorScheme.navigation.font.normal">mdi-trophy</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              <span :style="'color:'+$store.state.colorScheme.navigation.font.normal">Bounty</span>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>-->
        <!-- Achievements -->
        <!-- <v-list-tile  to="/achievement">
          <v-list-tile-action >
            <v-icon :style="'color:'+$store.state.colorScheme.navigation.font.normal">mdi-seal</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title><span :style="'color:'+$store.state.colorScheme.navigation.font.normal">Achievements</span></v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>-->
        <!-- Manage Invites -->
        <v-list-tile title="Manage Invites" to="/manageinvites">
          <v-list-tile-action>
            <v-badge
              v-model="showPendingInvitesBadge"
              color="rgba(193, 71, 88, 0.9)"
            >
              <template v-slot:badge>
                <span>{{ $store.state.pendingInvitesCount }}</span>
              </template>
              <v-icon
                :style="
                  'color:' + $store.state.colorScheme.navigation.font.normal
                "
                >mdi-calendar</v-icon
              >
            </v-badge>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              <span
                class="font-weight-bold"
                :style="
                  'color:' + $store.state.colorScheme.navigation.font.normal
                "
                >Manage Invites</span
              >
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <!-- Teams -->
        <v-list-tile title="Manage Team" to="/teammembers">
          <v-list-tile-action>
            <v-icon
              :style="
                'color:' + $store.state.colorScheme.navigation.font.normal
              "
              >mdi-account-group-outline</v-icon
            >
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              <span
                class="font-weight-bold"
                :style="
                  'color:' + $store.state.colorScheme.navigation.font.normal
                "
                >Manage Team</span
              >
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <!-- User Transactions -->
        <v-list-tile title="Store Transactions" to="/usertransactions">
          <v-list-tile-action>
            <v-icon
              :style="
                'color:' + $store.state.colorScheme.navigation.font.normal
              "
              >mdi-tag-outline</v-icon
            >
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              <span
                class="font-weight-bold"
                :style="
                  'color:' + $store.state.colorScheme.navigation.font.normal
                "
                >Store Transactions</span
              >
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <!-- Email Templates -->
        <v-list-tile
          title="Email Templates"
          to="/emailtemplates"
          v-if="
            ($store.getters.userIsAdministrativeOrOrgOwner ||
              $store.getters.isHRManager) &&
            !$store.getters.isCurrentOrgChild
          "
        >
          <v-list-tile-action>
            <v-icon
              :style="
                'color:' + $store.state.colorScheme.navigation.font.normal
              "
              >mdi-email-outline</v-icon
            >
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              <span
                class="font-weight-bold"
                :style="
                  'color:' + $store.state.colorScheme.navigation.font.normal
                "
                >Email Templates</span
              >
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <!-- Analytics -->
        <v-list-tile
          title="Analytics"
          to="/analytics"
          v-if="
            ($store.getters.isOrgOwner ||
              $store.getters.isHRManager ||
              $store.getters.isOrgAdmin ||
              $store.getters.isSuperAdmin) &&
            !$store.getters.isCurrentOrgChild
          "
        >
          <v-list-tile-action>
            <v-icon
              :style="
                'color:' + $store.state.colorScheme.navigation.font.normal
              "
              >mdi-chart-bar</v-icon
            >
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              <span
                class="font-weight-bold"
                :style="
                  'color:' + $store.state.colorScheme.navigation.font.normal
                "
                >Analytics</span
              >
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <!-- Store -->
        <v-list-tile
          title="Store"
          :href="$store.state.storeUrl"
          target="_blank"
        >
          <v-list-tile-action>
            <v-icon
              :style="
                'color:' + $store.state.colorScheme.navigation.font.normal
              "
              >mdi-store</v-icon
            >
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              <span
                class="font-weight-bold"
                :style="
                  'color:' + $store.state.colorScheme.navigation.font.normal
                "
                >Store</span
              >
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider color="#515151"></v-divider>
        <!-- Support -->
        <v-list-tile title="Support" to="/support">
          <v-list-tile-action>
            <v-icon
              :style="
                'color:' + $store.state.colorScheme.navigation.font.normal
              "
              >mdi-help-circle-outline</v-icon
            >
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              <span
                class="font-weight-bold"
                :style="
                  'color:' + $store.state.colorScheme.navigation.font.normal
                "
                >Support</span
              >
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <!-- <v-list dense>
        <div class="footer-copy" v-if="!mini">
          <a
            href="https://www.giveovation.com/"
            target="_blank"
            title="www.giveovation.com"
          >
            <v-img
              height="60px"
              :src="require('@/assets/img/logo-Ovation.v3.png')"
              contain
            ></v-img>
          </a>

          <p class="text-xs-center">20900 Swenson Drive, Suite 300</p>
          <p class="text-xs-center">Waukesha, WI 53186, USA</p>
        </div>
      </v-list> -->
      <v-list dense>
        <div v-if="!mini" class="caption halfwhite-text mt-4">
          {{ $store.state.appVersion }}
        </div>
      </v-list>
    </v-navigation-drawer>

    <!-- MAIN TOOLBAR -->
    <v-toolbar
      clipped-left
      style="padding-left: 1px !important"
      app
      absolute
      scroll-off-screen
      :style="$store.state.colorScheme.toolbar.background"
    >
      <v-toolbar-side-icon
        v-if="!drawer"
        @click.stop="drawer = !drawer"
      ></v-toolbar-side-icon>
      <div class="ml-0">
        <img
          height="40px"
          style="height: 40px"
          :src="require('@/assets/img/logo-Ovation.v3.png')"
        />
      </div>
      <v-toolbar-title
        class="headline text-uppercase mt-2 hidden-sm-and-down"
        :style="toolbarTitleLeftMargin"
      >
        <span class="nav-halfwhite-text font-weight-bold">
          {{ $store.getters.getCurrentOrgName }}
          <span class="caption font-weight-light font-italic">{{
            $store.getters.isCurrentOrgSet
              ? $store.getters.isCurrentOrgActive
                ? ""
                : "(Disabled)"
              : ""
          }}</span>
        </span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <div class="nav-halfwhite-text hidden-sm-and-down px-2 mr-2">
        <span>Welcome, </span>
        <span class="font-weight-bold"
          >{{ (this.$store.state.userSelf.profile || {}).firstname }}
          {{ (this.$store.state.userSelf.profile || {}).lastname }}</span
        >
      </div>
      <!-- User profile Menu via click on user avatar -->
      <v-menu left offset-y v-model="menu">
        <v-btn slot="activator" icon>
          <v-avatar color="primary" size="40">
            <img
              v-if="$store.getters.isProfileImageSet"
              :src="$store.getters.getProfileImageUrl"
              :alt="$store.getters.getUserFullName"
              :title="$store.getters.getUserFullName"
            />
            <span v-else class="white--text" style="padding: 0 8px">{{
              this.$store.getters.getUserInitials
            }}</span>
          </v-avatar>
          <v-icon class="nav-halfwhite-text" v-if="!menu"
            >mdi-chevron-down</v-icon
          >
          <v-icon class="nav-halfwhite-text" v-if="menu">mdi-chevron-up</v-icon>
        </v-btn>
        <v-list dense class="mt-1">
          <v-list-tile>
            <v-list-tile-content>
              <v-list-tile-title>
                <span class="font-weight-medium"
                  >{{ (this.$store.state.userSelf.profile || {}).firstname }}
                  {{
                    (this.$store.state.userSelf.profile || {}).lastname
                  }}</span
                >
              </v-list-tile-title>
              <v-list-tile-sub-title>{{
                (($store.state.userSelf.currentOrg || {}).org || {}).name
              }}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider></v-divider>
          <v-list-tile to="/profile">
            <v-list-tile-action>
              <v-icon
                :style="
                  'color:' + $store.state.colorScheme.navigation.font.dark
                "
                >mdi-account-outline</v-icon
              >
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                <span
                  class="font-weight-bold"
                  :style="
                    'color:' + $store.state.colorScheme.navigation.font.dark
                  "
                  >Profile</span
                >
              </v-list-tile-title></v-list-tile-content
            >
          </v-list-tile>
          <!-- <v-list-tile to="/newuserwizard" v-if="!$store.getters.isSuperAdmin">
            <v-list-tile-action>
              <v-icon>mdi-package-variant</v-icon>
            </v-list-tile-action>
            <v-list-tile-title>
              <span>New User Wizard</span>
            </v-list-tile-title>
          </v-list-tile>
          <v-list-tile to="/myinvites" v-if="!$store.getters.isSuperAdmin">
            <v-list-tile-action>
              <v-icon>mdi-email-check</v-icon>
            </v-list-tile-action>
            <v-list-tile-title>
              <span>Accept Invites</span>
            </v-list-tile-title>
          </v-list-tile>
          <v-list-tile
            to="/invite"
            v-if="$store.getters.userIsAdministrativeOrOrgOwner"
          >
            <v-list-tile-action>
              <v-icon>mdi-email</v-icon>
            </v-list-tile-action>
            <v-list-tile-title>
              <span>Invite to Organization</span>
            </v-list-tile-title>
          </v-list-tile> -->
          <v-list-tile to="/switchorg">
            <v-list-tile-action>
              <v-icon
                :style="
                  'color:' + $store.state.colorScheme.navigation.font.dark
                "
                >mdi-repeat</v-icon
              >
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                <span
                  class="font-weight-bold"
                  :style="
                    'color:' + $store.state.colorScheme.navigation.font.dark
                  "
                  >Switch Organization</span
                >
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile to="/support">
            <v-list-tile-action>
              <v-icon
                :style="
                  'color:' + $store.state.colorScheme.navigation.font.dark
                "
                >mdi-help-circle-outline</v-icon
              >
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                <span
                  class="font-weight-bold"
                  :style="
                    'color:' + $store.state.colorScheme.navigation.font.dark
                  "
                  >Support</span
                >
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider></v-divider>
          <v-list-tile @click="$store.dispatch('auth0Logout')">
            <v-list-tile-action>
              <v-icon
                :style="
                  'color:' + $store.state.colorScheme.navigation.font.dark
                "
                >mdi-logout</v-icon
              >
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                <span
                  class="font-weight-bold"
                  :style="
                    'color:' + $store.state.colorScheme.navigation.font.dark
                  "
                  >Log Out</span
                >
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>
    <!-- <iframe
      v-if="$store.state.storeLogout"
      :src="$store.state.storeLogout"
      style="display: none"
    ></iframe> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      drawer: true,
      right: null,
      mini: false,
      menu: false,
      userProfileImage: "",
      showPendingInvitesBadge: this.$store.state.pendingInvitesCount > 0,
      toolbarTitleLeftMargin: "margin-left:130px",
    };
  },
  watch: {
    "$store.state.pendingInvitesCount": function () {
      this.showPendingInvitesBadge = this.$store.state.pendingInvitesCount > 0;
    },
  },
  computed: {},
  methods: {
    setTitleMargin() {
      this.toolbarTitleLeftMargin = this.mini
        ? "margin-left:15px"
        : "margin-left:130px";
    },
  },
  beforeMount() {
    if (this.$store.state.userSelf.profile) {
      if (this.$store.state.userSelf.profile.isavatarlocal) {
        this.userProfileImage = this.$store.state.userSelf.profile.avatarlocal;
      } else {
        this.userProfileImage = this.$store.state.userSelf.profile.avatar;
      }
    }
  },
};
</script>

<style>
.v-navigation-drawer .v-list {
  background: transparent;
}
</style>